import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { Approval } from './approvals.types';

@Injectable({
  providedIn: 'root',
})
export class ApprovalsService {
  constructor(private httpClient: HttpClient) {}

  getApprovalById(id: number): Observable<Approval> {
    return this.httpClient
      .get<{ approval: Approval }>(`approvals/${id}`, {})
      .pipe(map((response) => response.approval));
  }

  approve(id: number): Observable<Approval> {
    return this.httpClient
      .put<{ approval: Approval }>(`approvals/${id}/approve`, {})
      .pipe(map((response) => response.approval));
  }

  decline(id: number, note: string): Observable<Approval> {
    return this.httpClient
      .put<{ approval: Approval }>(`approvals/${id}/decline`, {
        approval: {
          comments: note,
        },
      })
      .pipe(map((response) => response.approval));
  }
}
